<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->

    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel">
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 class="page-title text-primary">Anti Dumping</h2>
                </div>

                <div class="form" [hidden]="isShownWrite">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Notification Number</label><span style="color: red;">*</span><br />
                            <input type="text" id="NotifyNum" [(ngModel)]="NotifyNum" class="txt-input" />
                        </div>
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Serial Number </label><br />
                            <input type="text" id="SerialNum" [(ngModel)]="SerialNum" class="txt-input" />
                        </div>
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-lg-4" style="text-align: left;">
                            <label>Effective Date </label><span style="color: red;">*</span><br />
                            <input type="date" id="EffectDate" [(ngModel)]="EffectDate" class="txt-input" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 grid-margin">
                            <label>Document Upload</label><br />
                            <div class="col-lg-6" style="border: ridge;padding-bottom: 2em;">
                                <div class="clearfix">
                                    <div class="upload-btn-wrapper" style="padding-left: 50px;">
                                        <button class="btnUpload">Upload&nbsp; <img
                                                src="../../assets/UploadIcon.png">
                                        </button>
                                        <input type="file" #file (change)="uploadFile(file.files)" id="myfile"
                                            multiple />
                                    </div>
                                </div>
                                <div [hidden]="isShowndoclist">                                   
                                    <ol type="1" class="selects">
                                        <li *ngFor="let slt of selects;let index=index">
                                            <span><a href="{{slt.fileURL}}" target="_blank">{{slt.filename}}</a>
                                                <img src="../../assets/Delete_Icon.png"  (click)="RemoveDocument(slt,index)" />
                                            </span>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-5">
                            <label>Description</label> <br />
                            <textarea cols="40" rows="3" id="description" [(ngModel)]="description"
                                class="txt-input"></textarea>
                        </div>
                        <div class="col-lg-2" style="padding-top:60px;" [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                        </div>
                        <div class="col-lg-4" style="padding-top: 50px;">
                            <button class="bttn-save " (click)="SubmitNotify()" [hidden]="isShownSaveBtn">SAVE</button>
                            &nbsp;&nbsp;
                            <button class="bttn-Update" (click)="UpdateNotify()"
                                [hidden]="isShownUpdateBtn">Update</button>&nbsp;&nbsp;
                            <button class="bttn-clear " (click)="ClearNotify()">CLEAR</button>
                        </div>
                    </div>

                    <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                        <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                        <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                    </div>

                </div>
            </div>

            <div class="content-wrapper">
                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body" style="width:fit-content;">
                                <div class="row">
                                    <div class="col-12 grid-margin">
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-5"></div>
                                                    <div class="col-lg-7">
                                                        <div class="form-group">
                                                            <div class="input-group">
                                                                <!-- <label style="padding-right: 25px;">Search</label> -->
                                                                <input type="text" placeholder="Search"
                                                                    [(ngModel)]="searchText"
                                                                    (keyup)="applyFilter($event.target.value)"
                                                                    class="txt-Search"> <i class="fa fa-search fa-2x"
                                                                    style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                                <!-- <input type="text" class="form-control"
                                                                    placeholder="Search..." aria-label="Search..."
                                                                    aria-describedby="basic-addon2">
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-sm btn-gradient-danger"
                                                                        type="button">Search</button>
                                                                </div> -->
                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color: black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="notifynum">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Notification Number</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCustNotify(element)"
                                                                style="cursor: pointer;">
                                                                {{element.notifynum}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="serialnum">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Serial Number</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCustNotify(element)"
                                                                style="cursor: pointer;">
                                                                {{element.serialnum}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="datetime1">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Date</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCustNotify(element)"
                                                                style="cursor: pointer;">
                                                                {{element.datetime1}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditCustNotify(element)"
                                                                style="cursor: pointer;">
                                                                {{element.status}}
                                                            </td>
                                                        </ng-container>
                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">
                                        <!-- <p class="text-primary" style="float:right"><i>
                                                &nbsp;</i>Page 1,2,3,4<i>&nbsp;></i></p> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- partial:../../partials/_footer.html -->
            <footer class="footer">
                <div class="d-sm-flex justify-content-center">
                    <span class="d-block d-sm-inline-block">
                        © 2020 All Rights Reserved
                        <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
                            <img src="../../assets/Logo-V3.png" width="70" />
                        </a>

                    </span>

                </div>
            </footer>
            <!-- partial -->
        </div>

    </div>
</div>